import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { useTranslation } from 'react-i18next';
import { AssetApprovalStatus, useGetApprovalQuery } from '@casops/store/apis/assetApprovalsApi';
import ApprovalStatusNotification from './components/approval-status-notification/ApprovalStatusNotification';
import ApprovalManager from './components/approval-manager/ApprovalManager';
import ConflictManager from './components/conflict-manager/ConflictManager';
import { useListConfigurationGroupsQuery } from '@casops/store/apis/configurationGroupsApi';
import { useListAssetGroupsQuery } from '@casops/store/apis/assetGroupsApi';
import styles from './ManageAssetApproval.module.scss';

export function ManageAssetApproval(): ReactElement {
  const { t } = useTranslation();

  const { isLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetApprovalQuery,
  });

  const { data: configGroups } = useListConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const { data: assetGroups } = useListAssetGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  // The renderKey must update whenever the item and data dependencies change.
  const renderKey = useRenderKey({ item, configGroups, assetGroups });

  return (
    <DrawerPanel isLoaded={isLoaded} header={t('AssetApproval')}>
      {/* Narrow the 'item' type to simplify child component props. */}
      {item && (
        <div className={styles.container} key={renderKey}>
          <ApprovalStatusNotification status={item.sts} />

          {item.sts === AssetApprovalStatus.Conflict ? (
            <ConflictManager item={item} />
          ) : (
            <ApprovalManager item={item} />
          )}
        </div>
      )}
    </DrawerPanel>
  );
}

export default ManageAssetApproval;
